/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export enum TopicStatus {
    Draft = 'draft',
    Published = 'published',
    Public = 'public'
}

export enum AudienceType {
    Nvidia = 'NVIDIA',
    Partners = 'PARTNERS',
    Public = 'PUBLIC',
    GamePartner = 'GAME_PARTNER',
    GdnPartner = 'GDN_PARTNER'
}

export enum DestinationType {
    Gdp = 'GDP',
    Chatbot = 'CHATBOT'
}

export interface Topic {
    title: string;
    path: string;
    description: string;
    lastPublished: string;
    status: TopicStatus;
    audience: AudienceType[];
    destination: DestinationType[];
    requiredFeatures: string[];
    imagePath?: string;
    playtestPortalTags?: string;
    playtestPortalPostRunButton?: string;
}

export interface LearnCategory {
    category: string;
    topics: Topic[];
    target: string[];
    icon?: string;
    description?: string;
}

export interface PublicLearnData {
    data: LearnCategory[];
}
